export default __webpack_public_path__ + "static/media/togodo-logo-blue.932bf7d3.svg";